// extracted by mini-css-extract-plugin
export default {"zoomModal":"N1-z"};